// src/components/document/DocumentChecklist.tsx
import React from 'react';
import { Check } from 'lucide-react';
interface DocumentChecklistItem {
  id: string;
  text: string;
  isComplete: boolean;
}

interface DocumentChecklistProps {
  items: DocumentChecklistItem[];
  onToggleItem: (itemId: string) => void;
}

const DocumentChecklist: React.FC<DocumentChecklistProps> = ({ items, onToggleItem }) => {
  return (
    <div className="space-y-3">
      {items.map(({ id, text, isComplete }) => (
        <div key={id} className="flex items-center gap-4"> 
          <button
            onClick={() => onToggleItem(id)}
            aria-label={`Toggle task: ${text}`}
            className={`
              flex-shrink-0 w-6 h-6 rounded-md border-2 border-black
              flex items-center justify-center transition-all duration-200
              transform hover:-translate-y-px hover:shadow-[2px_2px_0_0_#000]
              active:translate-y-0 active:shadow-none focus:outline-none 
              focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-emerald-500
              ${isComplete ? 'bg-emerald-400' : 'bg-white'}
            `}
          >
            {isComplete && <Check className="w-4 h-4 text-black" strokeWidth={3} />}
          </button>
          <span className={`text-slate-800 ${isComplete ? 'line-through text-slate-500' : ''}`} dangerouslySetInnerHTML={{ __html: text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')}}/>
        </div>
      ))}
    </div>
  );
};

export default DocumentChecklist;
